import React from "react";

const Loading = () => {
  return (
    <div className="loading-container">
      {/* <Lottie animationData={loadingAnimation} loop={true} style={{ width: 200, height: 200 }} /> */}
      <p>Loading...</p>
    </div>
  );
};

export default Loading;
